import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { HttpService } from "../../services/HttpService";
import { useSelector } from "react-redux";
import BoxShareLink from "./boxShareLink";

const PopUpLinkPublicCalendars = (props: any) => {
  const { t } = useTranslation();
  let show = props.show ?? true;
  const { eventId } = useSelector((state: any) => state.login);
  const [eventHash, setEventHash] = useState("");
  const closePopUp = () => {
    if (typeof props.closePopUp === 'function') {
      props.closePopUp()
    }
  }

  const init = async () => {
    try {
      if (eventHash === "") {
        const result = await HttpService.post(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/guestappTokens`, {});
        const { guestappToken } = result?.data;
        if (guestappToken) {
          setEventHash(guestappToken?.eventHash)
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init()
  }, [])
  return (
    <Modal className="ModalSection EditCategoryTimeslot PopUpEmailSchedule =" show={show} onHide={closePopUp} >
      <Modal.Header closeButton>
        {t('links-public-calendars')}
      </Modal.Header>
      <Modal.Body>
        <div className="col-lg-12 ">



          <BoxShareLink label={t("label-institutional-services")} url={`${process.env.REACT_APP_GUESTAPP}/calendar/event/${eventHash}?external=1`} />
          <BoxShareLink label={t("label-free-pharmacy-services")} url={`${process.env.REACT_APP_GUESTAPP}/calendar/event/${eventHash}?external=0`} />
          <BoxShareLink label={t("label-all-services")} url={`${process.env.REACT_APP_GUESTAPP}/calendar/event/${eventHash}?external=2`} />
        </div>
      </Modal.Body>
      <Modal.Footer>

      </Modal.Footer>
    </Modal>
  )
}

export default PopUpLinkPublicCalendars

